import { useTranslation } from 'react-i18next';
import { Grid, Paper, Stack, Typography } from '@mui/material';
import { MasterAttribute } from '../types';

interface OverviewTabProps {
  attribute: MasterAttribute;
  usageCount: number;
}

const SummaryBlock = ({ label, value }: { label: string; value: string }) => (
  <Stack spacing={0.5}>
    <Typography variant="textXS"
      color="text.secondary">{label}</Typography>
    <Typography variant="textMD"
      fontWeight={600}>{value}</Typography>
  </Stack>
);

const OverviewTab = ({ attribute, usageCount }: OverviewTabProps) => {
  const { t } = useTranslation('attributesAllergens');

  return (
    <Paper variant="outlined"
      sx={{ p: 4 }}>
      <Grid container
        spacing={5}>
        <Grid item
          md={3}
          sm={6}
          xs={12}>
          <SummaryBlock label={t('code', 'Code')}
            value={attribute.code} />
        </Grid>
        <Grid item
          md={3}
          sm={6}
          xs={12}>
          <SummaryBlock label={t('categoryLabel', 'Category')}
            value={t(`category.${attribute.category}`, attribute.category)} />
        </Grid>
        <Grid item
          md={3}
          sm={6}
          xs={12}>
          <SummaryBlock label={t('regulatory', 'Regulatory')}
            value={attribute.isRegulatory ? t('yes', 'Yes') : t('no', 'No')} />
        </Grid>
        <Grid item
          md={3}
          sm={6}
          xs={12}>
          <SummaryBlock label={t('usageCount', 'Used By')}
            value={t('entitiesCount', '{{count}} entities', { count: usageCount })} />
        </Grid>
        <Grid item
          xs={12}>
          <Stack spacing={0.5}>
            <Typography variant="textXS"
              color="text.secondary">{t('description', 'Description')}</Typography>
            <Typography variant="textSM">{attribute.description}</Typography>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default OverviewTab;
